import * as Yup from 'yup';
import Translator from '../../../services/translate-factory';

const validation = (T: Translator) =>
  Yup.object().shape({
    email: Yup.string().email(T.t('gen_must_valid_email_address')).required(T.t('gen_cannot_leave_empty')),
  });
export default validation;
